import { useAuth } from "@/auth";
import { WeightsTab } from "@/pages/Configuracion";
import { ShieldAlert } from "lucide-react";

export default function CategoryWeights() {
  const { user } = useAuth();
  const myCats = user?.assigned_categories || [];

  return (
    <div className="max-w-5xl mx-auto px-4 py-8" data-testid="category-weights-page">
      <div className="mb-6">
        <div className="font-hand text-xl text-[var(--lala-blue)]">category manager · pesos de tu categoría</div>
        <h1 className="font-display text-4xl sm:text-5xl">Pesos por pilar</h1>
        <p className="text-sm text-[var(--ink-soft)] mt-2 max-w-2xl">
          Aquí consultas cómo pesa cada pilar en la evaluación de los proveedores de tu categoría y el historial de cambios.
        </p>
        <div className="mt-3 sketch-border-soft bg-amber-50 border border-amber-300 p-3 text-sm flex items-start gap-2 max-w-2xl"
          data-testid="weights-readonly-banner">
          <ShieldAlert size={16} className="text-amber-600 mt-0.5 shrink-0" />
          <span>
            Como category manager <b>defines el criterio de negocio</b>, pero la modificación de pesos en la plataforma
            la realiza <b>únicamente el Administrador</b> (los cambios son excepcionales). Si tu categoría requiere un
            ajuste, solicítalo al administrador del programa.
          </span>
        </div>
      </div>
      {myCats.length === 0 ? (
        <div className="sketch-border bg-[var(--cream-soft)] p-8 text-center" data-testid="no-categories-msg">
          <p className="font-semibold">Aún no tienes categorías asignadas.</p>
          <p className="text-sm text-[var(--ink-soft)] mt-1">Pide al administrador que te asigne tu categoría de compra en Usuarios y permisos.</p>
        </div>
      ) : (
        <WeightsTab allowedCategories={myCats} buyerMode />
      )}
    </div>
  );
}
